module.exports = __webpack_public_path__ + "static/undraw_security_o890-22b2f0f85fd9fba4f3b6be64310044eb.svg";